<template>
  <div class="landpage-layout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'LandpageLayout',
  beforeDestroy() {
    // Clean up any landpage-specific stylesheets
    document.querySelectorAll('link[data-layout="landpage"]').forEach(link => link.remove());
  }
};
</script>

<style scoped>
.landpage-layout {
  min-height: 100vh;
}
</style>
